module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    attrs: {
      "border": "1"
    }
  }, [(_vm.title != '') ? _c('caption', [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _c('tr', _vm._l((_vm.columnNames), function(key) {
    return _c('th', {
      key: key.name || key
    }, [_vm._v(_vm._s(key.name || key))])
  }), 0), _vm._v(" "), _vm._l((_vm.rows), function(row, index) {
    return _c('editable-row', {
      key: ("row-" + index),
      attrs: {
        "column-names": _vm.columnNames,
        "values": row,
        "save": _vm.onSave(index)
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61418286","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CommissionSetting2/IB/AlertIgnore/EditableTable.vue
// module id = 1118
// module chunks = 1